<div id="confirmationStep" class="row mr-1">
    <!-- This is only show for Ipad device else hidden -->
    <div class="col-12 col-lg-12 d-none d-sm-none d-md-none d-lg-none d-xl-none">
        <!-- title -->
        <ng-container *ngIf="this.confirmation.UnderwritingStatus === undefined || 
                            (this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined && this.confirmation.UnderwritingStatus !== UnderwritingStatus.Unknown)
                            ">
            <div class="step-header-text" *ngIf="!isAppeal && this.confirmation.UnderwritingStatus !== undefined">
                <mat-icon class="success">done</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
            </div>

            <div class="step-header-text" *ngIf="this.confirmation.UnderwritingStatus === undefined">
                <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
            </div>

            <div class="step-header-text-warning" *ngIf="isAppeal">
                <mat-icon class="warning">done</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title_Warning"></adp-label>
            </div>
        </ng-container>

        <ng-container
            *ngIf="this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined">
            <div class="step-header-text-red" *ngIf="!isAppeal">
                <mat-icon class="decline">close</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title_Declined"></adp-label>
            </div>

            <div class="step-header-text-warning" *ngIf="isAppeal">
                <mat-icon class="warning">done</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title_Warning"></adp-label>
            </div>
        </ng-container>

        <ng-container
            *ngIf="!isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
            <div class="step-header-text-warning">
                <mat-icon class="warning">done</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title"></adp-label>
            </div>
        </ng-container>

        <!-- Confirmation Title for ACC -->
        <ng-container
            *ngIf="isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
            <div class="step-header-text">
                <mat-icon class="success">done</mat-icon>
                <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
            </div>
        </ng-container>

        <!-- description -->
        <div *ngIf="showConfirmationStepTextDescription" class="col-12 pl-0 step-header-description pr-0">
            <ng-container
                *ngIf="this.confirmation.UnderwritingStatus === undefined || (this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined && this.confirmation.UnderwritingStatus !== UnderwritingStatus.Unknown)">

                <div
                    *ngIf="this.confirmation.UnderwritingStatus === undefined || (!isAppeal && this.confirmation.UnderwritingStatus === UnderwritingStatus.Approved)">
                    <adp-label labelKey="ConfirmationStep_Text_Description"></adp-label>
                </div>

                <div *ngIf="isAppeal && this.confirmation.UnderwritingStatus === UnderwritingStatus.Approved">
                    <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined_AppealYes">
                    </adp-label>
                </div>
            </ng-container>

            <ng-container
                *ngIf="!isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                <div>
                    <adp-label labelKey="ConfirmationStep_Text_Description_PHI"></adp-label>
                </div>
            </ng-container>

            <ng-container
                *ngIf="!isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined && isAppeal">
                <div>
                    <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined_AppealYes"></adp-label>
                </div>
            </ng-container>



            <!-- Description for ACC -->
            <ng-container
                *ngIf="isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                <div>
                    <adp-label labelKey="ConfirmationStep_Text_Description"></adp-label>
                </div>
            </ng-container>


        </div>
    </div>
    <!-- application description section -->
    <div class="col-12 col-lg-12 largePaddingLeft d-xs-block d-sm-block d-md-block d-lg-block d-xl-block">
        <div class="row">
            <!-- title -->
            <ng-container
                *ngIf="this.confirmation.UnderwritingStatus === undefined || (this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined && this.confirmation.UnderwritingStatus !== UnderwritingStatus.Unknown)">
                <div class="step-header-text" *ngIf="!isAppeal && this.confirmation.UnderwritingStatus !== undefined">
                    <mat-icon class="success">done</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
                </div>

                <div class="step-header-text" *ngIf="this.confirmation.UnderwritingStatus === undefined">
                    <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
                </div>

                <div class="step-header-text-warning" *ngIf="isAppeal">
                    <mat-icon class="warning">done</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Warning"></adp-label>
                </div>
            </ng-container>

            <ng-container
                *ngIf="this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined">
                <div class="step-header-text-red" *ngIf="!isAppeal">
                    <mat-icon class="decline">close</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Declined"></adp-label>
                </div>

                <div class="step-header-text-warning" *ngIf="isAppeal">
                    <mat-icon class="warning">done</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Warning"></adp-label>
                </div>
            </ng-container>

            <ng-container
                *ngIf="!isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                <div class="step-header-text-warning">
                    <mat-icon class="warning">done</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Warning"></adp-label>
                </div>
            </ng-container>

            <!-- Confirmation Title for ACC -->
            <ng-container
                *ngIf="isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                <div class="step-header-text">
                    <mat-icon class="success">done</mat-icon>
                    <adp-label labelKey="ConfirmationStep_Text_Title_Success"></adp-label>
                </div>
            </ng-container>

            <!-- description -->
            <div *ngIf="showConfirmationStepTextDescription"
                class="col-12 step-header-description p-0">
                <ng-container
                    *ngIf="this.confirmation.UnderwritingStatus === undefined || (this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined && this.confirmation.UnderwritingStatus !== UnderwritingStatus.Unknown)">
                    <div *ngIf="!isAppeal && this.confirmation.UnderwritingStatus !== undefined">
                        <adp-label labelKey="ConfirmationStep_Text_Description"></adp-label>
                    </div>

                    <div *ngIf="this.confirmation.UnderwritingStatus === undefined">
                        <adp-label labelKey="ConfirmationStep_Text_Description"></adp-label>
                    </div>

                    <div *ngIf="isAppeal && this.confirmation.UnderwritingStatus === UnderwritingStatus.Approved">
                        <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined_AppealYes">
                        </adp-label>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined">

                    <!-- <div *ngIf="!isAppeal">
                        <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined"></adp-label>
                    </div> -->

                    <div *ngIf="isAppeal">
                        <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined_AppealYes">
                        </adp-label>
                    </div>

                    <!-- <div class="mt-5 mb-5"
                        *ngIf="!isAppeal && this.confirmation.UnderwritingStatus  === UnderwritingStatus.Declined">
                        <adp-label labelKey="ConfirmationStep_Text_CustomerServicePhoneNumber">
                        </adp-label>
                    </div>-->
                </ng-container>

                <ng-container
                    *ngIf="!isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                    <div>
                        <adp-label labelKey="ConfirmationStep_Text_Description_PHI"></adp-label>
                    </div>
                </ng-container>

                <!-- Description for ACC -->
                <ng-container
                    *ngIf="isAccProgram() && this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Unknown">
                    <div>
                        <adp-label labelKey="ConfirmationStep_Text_Description"></adp-label>
                    </div>
                </ng-container>

            </div>
            <div class="col-12">
                <!-- Pdf Receipt -->
                <div id="div1" class="btn-container"
                    *ngIf="sale?.PaymentMethodInfo?.PaymentMethodType === showPrintReceiptPaymentmethod">
                    <button class="btn btn-default" (click)="getReceiptDoc()">{{
                        resourceService.getViewLabel("Confirmation_Text_PrintReceipt") }}</button>
                </div>
                <!-- new application action -->
                <div id="div2_1" class="btn-container mt-0 float-left invisble" *ngIf="isConnectedLivingFlow"
                    [class.mb-5]="this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined"
                    [class.mb-md-0]="this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined">

                    <adp-button (clickEventCb)="newApplication()"
                        [resourceData]="resourceService.getViewResourceObject('ConfirmationStep_NewApplication_Button')"
                        [styleClass]="'btn-primary new-btn-continue m-0 radius-button'">
                    </adp-button>

                    <adp-button (clickEventCb)="goToMembershipPage()" [ngStyle]="{'margin-left':'25px'}"
                        [resourceData]="resourceService.getViewResourceObject('ConfirmationStep_Memberships_Button')"
                        [styleClass]="'btn-primary new-btn-continue m-0 radius-button'">
                    </adp-button>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-12 largePaddingLeft"
        *ngIf="this.confirmation.UnderwritingStatus  === undefined || this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined || (this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined && isAppeal)">
        <mat-expansion-panel class="custom-expansion-panel" disabled expanded>
            <!-- title -->
            <div class="row pb-4 pt-4 pl-2 pr-2 details-title alternate-bg-color">
                <div class="col-12">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsTitle"></adp-label>
                </div>
            </div>


            <!-- Name -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showName">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_Name"></adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{confirmation.Name}}</span>
                </div>
            </div>


            <!-- Address -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showAddress">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_Address"></adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{confirmation.Address}}</span>
                </div>
            </div>

            <!-- reference number -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showReferenceNumber">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsReferenceNumber"></adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{confirmation.ReferenceNumber}}</span>
                </div>
            </div>

            <!-- Unique Mandate Reference -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showReferenceNumberURM && paymentFrequency!=12">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsReferenceNumberURM">
                    </adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{confirmation.ReferenceNumber}} - 1</span>
                </div>
            </div>

            <!-- effective date -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsEffectiveDate"></adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{formatDate()}}</span>
                </div>
            </div>
            <!-- plan name -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="!showReferenceNumber">
                <div class="col-12 col-md-4 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsPlanName"></adp-label>
                </div>
                <div class="col-12 col-md-8 step-card-content cardRightAlign">{{this.confirmation.PlanName}}</div>
            </div>
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showReferenceNumber">
                <div class="col-12 col-md-4 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsPlanName"></adp-label>
                </div>
                <div class="col-12 col-md-8 step-card-content cardRightAlign">{{this.confirmation.PlanName}}</div>
            </div>


            <!-- Payment Frequency -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showPaymentFrequency">
                <div class="col-12 col-md-4 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_PaymentFrequency"></adp-label>
                </div>
                <div class="col-12 col-md-8 step-card-content cardRightAlign">{{confirmation.PaymentFrequency}}</div>
            </div>

            <!-- Rate -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showRate">
                <div class="col-12 col-md-4 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_Rate"></adp-label>
                </div>
                <div class="col-12 col-md-8 step-card-content cardRightAlign">{{currencyRate()}}</div>
            </div>

            <!--Date Of Birth-->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showDateOfBirth">
                <div class="col-12 col-md-4 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DateOfBirth">
                    </adp-label>
                </div>
                <div class="col-12 col-md-8 step-card-content cardRightAlign">{{confirmation.DateOfBirth}}</div>
            </div>

            <!-- description -->
            <div class="row border-top pb-4 pt-4 pl-2 pr-2" *ngIf="showDescription">
                <div class="col-12 step-card-content">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsDescription"></adp-label>
                </div>
            </div>
            <!-- CS Telephone Number -->
            <div class="row pb-4 pl-2 pr-2" *ngIf="showPhoneNumber">
                <div class="col-12 step-card-content">
                    <adp-label labelKey="ConfirmationStep_Text_CustomerServicePhoneNumber">
                    </adp-label>
                </div>
            </div>
        </mat-expansion-panel>
    </div>

    <div class="col-12 col-lg-12 largePaddingLeft detailsPaddingTop datailsMaringTop"
        *ngIf="this.confirmation.UnderwritingStatus !== undefined && this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined && !isAppeal">
            <mat-expansion-panel class="custom-expansion-panel" disabled expanded>
            <!-- title -->
            <div class="row pb-4 pt-4 pl-2 pr-2 details-title alternate-bg-color">
                <div class="col-12">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsTitle"></adp-label>
                </div>
            </div>

            <!-- reference number -->
            <div class="row border-top pb-3 pt-3 pl-2 pr-2" *ngIf="showReferenceNumber">
                <div class="col-12 col-md-6 details-title">
                    <adp-label labelKey="ConfirmationStep_Text_DetailsReferenceNumber"></adp-label>
                </div>
                <div class="col-12 col-md-6 step-card-content cardRightAlign">
                    <span>{{confirmation.ReferenceNumber}}</span>
                </div>
            </div>

            <!-- description -->
            <div class="row border-top pb-4 pt-4 pl-2 pr-2">
                <div class="col-12 step-card-content">
                    <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined" *ngIf="!isAppeal"></adp-label>
                    <adp-label labelKey="ConfirmationStep_Text_DescriptionDeclined_AppealYes" *ngIf="isAppeal">
                    </adp-label>
                </div>
            </div>

            <!-- CS Telephone Number -->
            <div class="row pb-4 pl-2 pr-2" *ngIf="showPhoneNumber">
                <div class="col-12 step-card-content">
                    <adp-label labelKey="ConfirmationStep_Text_CustomerServicePhoneNumber">
                    </adp-label>
                </div>
            </div>
        </mat-expansion-panel>
    </div>

    <div class="col-12 col-lg-12 d-none d-sm-none d-md-none d-lg-none d-xl-none">
        <!-- Pdf Receipt -->
        <div id="div1" class="btn-container pt-3"
            *ngIf="sale?.PaymentMethodInfo?.PaymentMethodType === showPrintReceiptPaymentmethod">
            <button class="btn btn-default" (click)="getReceiptDoc()">{{
                resourceService.getViewLabel("Confirmation_Text_PrintReceipt") }}</button>
        </div>
        <!-- new application action -->
        <div id="div2_2" class="btn-container mt-0 float-right pt-3 invisible" *ngIf="isConnectedLivingFlow"
            [class.mb-5]="this.confirmation.UnderwritingStatus === UnderwritingStatus.Declined"
            [class.mb-md-0]="this.confirmation.UnderwritingStatus !== UnderwritingStatus.Declined">
            <button class="btn btn-primary new-btn-continue m-0" (click)="newApplication()">
                {{ resourceService.getViewLabel("ConfirmationStep_Text_NewApplicationButton") }}
            </button>
        </div>
    </div>
</div>